var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"emotion-box"},_vm._l((_vm.list),function(line,i){return _c('div',{key:i,staticClass:"emotion-box-line"},_vm._l((line),function(item,ii){return _c('emotion',{key:ii,staticClass:"emotion-item",nativeOn:{"click":function($event){return _vm.clickHandler(item)}}},[_vm._v(_vm._s(item))])}),1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }